import {TT_SUBSPEC, TT_SPEC, TT_FAMILY, TT_GENUS, TT_ORDER} from '../Util.js';

/* Taxon tabs */
export const TAB_TAX		= 0;
export const TAB_STATS		= 1;
export const TAB_MAP		= 2;
export const TAB_DESC		= 3;
export const TAB_HALIAS		= 4;
export const TAB_MEDIA		= 5;
export const TAB_ATLAS		= 6;
export const TAB_BL		= 7;
export const TAB_MIGR		= 8;
export const TAB_REFS		= 9;

/* Stats tabs */
export const STAB_GEN		= 0;
export const STAB_NUM		= 1;
export const STAB_DATE		= 2;
export const STAB_MONTHS	= 3;
export const STAB_YEARS		= 4;

export function taxStateDesc(tt) {
	if (tt === TT_SUBSPEC)
		return 'taxons.subspecies';
	if (tt === TT_SPEC) 
		return 'taxons.species';
	if (tt === TT_GENUS)
		return 'taxons.genus';
	if (tt === TT_FAMILY)
		return 'taxons.family';
	if (tt === TT_ORDER)
		return 'taxons.order';

	return 'taxons.unknown';
}
